import SocialButton from 'components/SocialButton'
import StaticPopup from 'components/StaticPopup'
import TextTitleLight from 'components/TextTitleLight'
import { View } from 'components/View'
import {
  STYLES_MARGIN,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import { getShareUrlsSocialUtil } from 'utils/social'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { connect } from 'react-redux'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

function PageShareButtons ({
  title,
  url,
  img,
  style = {},
  isSmallScreen
}) {
  const handleClickSocial = (name, href) => {
    // Log analytics event
    logEventAnalyticsUtil('SHARE_BUTTON_CLICK', {
      social_network: name,
      page_title: title,
      page_url: url
    })

    // Open popup
    openPopup(href)
  }

  /**
   * Open a popup redirecting to the right url and with the right meta.
   * @param  {string} popupUrl The social network's sharing url
   */
  const openPopup = (popupUrl) => {
    const props = {
      title,
      url: popupUrl
    }
    new StaticPopup(props) // eslint-disable-line
  }

  const socialObj = getShareUrlsSocialUtil(title, url, img)
  const socialKeys = Object.keys(socialObj)

  return (
    <View
      className='page-shareButtons'
      style={getStyleComponentUtil(
        {
          padding: `${STYLES_PADDING.MEDIUM} 0`,
          justifyContent: isSmallScreen
            ? null
            : View.JUSTIFY.CENTER,
          alignItems: isSmallScreen
            ? View.ALIGN.CENTER
            : null
        },
        style
      )}
    >
      <TextTitleLight>
        Share it
      </TextTitleLight>
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          marginTop: STYLES_MARGIN.SMALLEST
        }}
      >
        {Object.keys(socialObj)
          .map((name) => {
            const href = socialObj[name]
            const isLast = (
              socialKeys.indexOf(name) ===
              socialKeys.length -
              1
            )
            return (
              <div
                key={name}
                style={{
                  marginRight: isLast
                    ? null
                    : STYLES_MARGIN.MEDIUM
                }}
              >
                <SocialButton
                  name={name}
                  title={title}
                  onClick={() => handleClickSocial(name, href)}
                />
              </div>
            )
          })}
      </View>
    </View>
  )
}

PageShareButtons.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  style: PropTypes.object,
  isSmallScreen: PropTypes.bool
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(PageShareButtons)
